export class TableData {
    name: string;
    value: string;
    constructor(name: string, value: number) {
        this.name = name;
        this.value = `${value}`;
    }
}
